// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080'

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://rocky-temple-53839.herokuapp.com"


// export const REACT_APP_API_BASE_URL="https://rocky-temple-53839.herokuapp.com/" 


// WEBPACK FOOTER //
// ./src/config.js